import { Component } from '@angular/core';
import { LoadingPage } from 'live-lesson/shared/feature-call-ui-react';
import { RenderReactDirective } from "shared/angular-react";

@Component({
    selector: 'pcp-login-loading',
    templateUrl: './login-loading.component.html',
    styleUrl: './login-loading.component.scss',
    imports: [
        RenderReactDirective,
    ],
})
export class LoginLoadingComponent {
    protected readonly ReactComponent = LoadingPage;
}
